import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import * as yup from "yup";
import dayjs from 'dayjs';
import {
  TextField,
  Button,
  Grid,
  Autocomplete,
} from "@mui/material";
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { 
  createViagio, 
  singleTrasporti, 
  updateTrasportoData 
} from "../../../features/trasporti/trasportiThunk";
import { fetchMezzi } from "../../../features/Mezzi/mezziThunk";
import { fetchGiacenze, updateGiacenzaData } from "../../../features/giacenze/giacenzeThunk";

dayjs.locale('it');

// Define your validation schema
const schema = yup.object().shape({
  autista: yup.string().required("Autista è obbligatorio"),
  trattore: yup.mixed(),
  mezzo: yup.mixed(),
  dataInizio: yup.date().required("Data inizio è obbligatoria"),
  dataFine: yup.date().required("Data fine è obbligatoria"),
  oreViaggio: yup.string().required("Ore di viaggio è obbligatorio"),
  partenza: yup.string().required("Partenza da è obbligatoria"),
  destinazione: yup.string().required("Destinazione a è obbligatoria"),
  vendita: yup.string().required("Vendita è obbligatoria"),
  casse: yup.mixed().required("Casse è obbligatorio"),
  formato: yup.string(),
  bottiglie: yup.string(),
  price: yup.string(),
});

const options = ["Amministratore", "Collaboratore", "Operatore"];

const TransportoForm = ({ singleData, setCantine, cantine }) => {
  // Price state to display Q.ta dis.
  const [price, setPrice] = useState(0);

  // Redux selectors: your options for trattori, vendita, giacenze and mezzo from Redux store
  const trattoriData = useSelector((store) => store.trasporto.trattori);
  const venditaData = useSelector((store) => store.trasporto.viaggio);
  const giacenzeData = useSelector((store) => store.giacenze.giacenze);
  const mezzoData = useSelector((store) => store.mezzi.mezzi);

  // Transform the data for Autocomplete
  const mezzo = mezzoData
    ?.filter(item => item?.tipo_mezzo === "Mezzo")
    .map(item => ({ id: item?.id, name: item?.name }));

  const trattori = mezzoData
    ?.filter(item => item?.tipo_mezzo === "Trattori")
    .map(item => ({ id: item?.id, name: item?.name }));

  // console.log("Mezzo:", mezzo);
  console.log("Trattori:", trattori);

  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Initial useEffect for resetting the form from singleData
  useEffect(() => {
    // Prepare a payload for reset with available fields from singleData
    const payload = {
      mezzi_id: null,
      autista: singleData?.vettore,
      trattore: singleData?.trattore,
      mezzo: singleData?.mezzo,
      dataInizio: singleData?.date_start ? dayjs(singleData?.date_start).format("YYYY-MM-DD") : null,
      dataFine: singleData?.date_end ? dayjs(singleData?.date_end).format("YYYY-MM-DD") : null,
      oreViaggio: singleData?.ore_viaggio,
      partenza: singleData?.partenanza_da,
      destinazione: singleData?.destinazione_a,
      vendita: singleData?.tipo_viaggio,
    };

    // Set some independent fields as well
    setValue("vendita", singleData?.tipo_viaggio || null);
    setValue("trattore", singleData?.trattore || null);
    setValue("mezzo", singleData?.mezzo || null);
    setValue("dataInizio", singleData?.date_start ? dayjs(singleData?.date_start) : null);
    setValue("dataFine", singleData?.date_end ? dayjs(singleData?.date_end) : null);
    
    // Reset the form values at once
    reset(payload);
  }, [singleData, reset, setValue]);

  useEffect(()=>{
    dispatch(fetchMezzi())
    dispatch(fetchGiacenze())
  },[])
  // Set dependent fields based on the selected "casse"
  useEffect(() => {
    if (singleData?.giacenze_id) {
      const selectedCassa = giacenzeData.find(item => item.id === singleData.giacenze_id);
      console.log(selectedCassa, "selectedCassa");
      if (selectedCassa) {
        setValue("casse", selectedCassa);
        setValue("formato", selectedCassa.formato || "");
        setValue("bottiglie", selectedCassa.um || "");
        setValue("price", selectedCassa.displonibile || "");
        setPrice(selectedCassa?.displonibile);
      }
    }
  }, [singleData, giacenzeData, setValue]);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (singleData) {
      const selectedMezzo = mezzo?.find(item => item.id == singleData?.mezzo);
      const selectedTrattore = trattori?.find(item => item.id == singleData?.trattore);
      setValue("mezzo", selectedMezzo);
      setValue("trattore", selectedTrattore);
      hasMounted.current = true;
    }
  }, [singleData, mezzo, trattori]);
  

  // Handle form submission
  const onSubmit = async (data) => {
    const payload = {
      mezzi_id: null,
      vettore: data.autista,
      trattore: data.trattore?.id,
      mezzo: data.mezzo?.id,
      date_start: data.dataInizio ? dayjs(data.dataInizio).format("YYYY-MM-DD") : null,
      date_end: data.dataFine ? dayjs(data.dataFine).format("YYYY-MM-DD") : null,
      ore_viaggio: data.oreViaggio,
      partenanza_da: data.partenza,
      destinazione_a: data.destinazione,
      tipo_viaggio: data.vendita,
      giacenze_id: data.casse?.id,
      displonibile:data?.price
    };
    const original = giacenzeData.find(item => item.id === data.casse?.id);
    const originalPrice = original?.displonibile;

    console.log(payload, "payload");

    if (singleData) {
        try {
            await dispatch(updateTrasportoData({ id: singleData?.id, data: payload })).unwrap();

            // ✅ Call updateGiacenza only if price changed
            if (originalPrice !== data.price) {
                await dispatch(updateGiacenzaData({ id: data.casse?.id, data: { displonibile: data.price } })).unwrap();
            }

            dispatch(singleTrasporti(singleData.id));
            localStorage.removeItem("viaggiLogistica");
            setCantine(false);
        } catch (err) {
            console.error("Update Error:", err);
        }
    } else {
        try {
            await dispatch(createViagio(payload)).unwrap();

            // ✅ Call updateGiacenza only if price changed
            if (originalPrice !== data.price) {
                await dispatch(updateGiacenzaData({ id: data.casse?.id, data: { displonibile: data.price } })).unwrap();
            }

            setCantine(false);
        } catch (err) {
            console.error("Create Error:", err);
        }
    }
};

  //   if (singleData) {
  //     dispatch(updateTrasportoData({ id: singleData?.id, data: payload }))
  //       .unwrap()
  //       .then(() => {
  //         dispatch(singleTrasporti(singleData.id));
  //         setCantine(false);
  //       })
  //       .catch((err) => console.error("Update Error:", err));
  //   } else {
  //     dispatch(createViagio(payload))
  //       .unwrap()
  //       .then(() => {
  //         setCantine(false);
  //       })
  //       .catch((err) => console.error("Create Error:", err));
  //   }
  // };

  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
          <label className="formLabel">Mezzi</label>
          <Controller
            name="autista"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                value={field.value || ""}
                label="Autista/vettore"
                fullWidth
                margin="normal"
                error={!!errors.autista}
                helperText={errors.autista?.message}
              />
            )}
          />

          <Controller
            name="trattore"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={trattori}
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trattore  (FR578)"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.trattore}
                    helperText={errors.trattore?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            name="mezzo"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={mezzo}
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Mezzo  (FR578)"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.mezzo}
                    helperText={errors.mezzo?.message}
                  />
                )}
              />
            )}
          />

          <label className="formLabel">Viaggio</label>
          <Grid container spacing={1}>
            <Grid size={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <Controller
                  name="dataInizio"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      label="Data inizio"
                      className='datePickerField'
                      value={field.value ? dayjs(field.value) : null}
                      onChange={(newValue) => field.onChange(newValue)}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <Controller
                  name="dataFine"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      label="Data Fine"
                      className='datePickerField'
                      value={field.value ? dayjs(field.value) : null}
                      onChange={(newValue) => field.onChange(newValue)}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={4}>
              <Controller
                name="oreViaggio"
                control={control}
                render={({ field }) => (
                  <TextField
                    className="customTextBox"
                    {...field}
                    value={field.value || ""}
                    label="Ore Viaggio"
                    fullWidth
                    margin="normal"
                    error={!!errors.oreViaggio}
                    helperText={errors.oreViaggio?.message}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Controller
            name="partenza"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                value={field.value || ""}
                label="Partenza da"
                fullWidth
                margin="normal"
                error={!!errors.partenza}
                helperText={errors.partenza?.message}
              />
            )}
          />
          <Controller
            name="destinazione"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                value={field.value || ""}
                label="Destinazione a"
                fullWidth
                margin="normal"
                error={!!errors.destinazione}
                helperText={errors.destinazione?.message}
              />
            )}
          />

          <label className="formLabel">Trasporto</label>
          <Controller
            name="vendita"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={venditaData}
                value={field.value || null} // ✅ Ensure a value is set
                onChange={(event, value) => setValue("vendita", value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendita"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.vendita}
                    helperText={errors.vendita?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            name="casse"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={giacenzeData}
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => {
                  field.onChange(value); // Set the full object
                  if (value) {
                    setValue("formato", value.formato || "");
                    setValue("bottiglie", value.um || "");
                    setValue("price", value.displonibile || "");
                    setPrice(value.displonibile);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chianti classico 2019"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.casse}
                    helperText={errors.casse?.message}
                  />
                )}
              />
            )}
          />

          <Grid container spacing={1}>
            <Grid size={5}>
              <Controller
                name="formato"
                control={control}
                render={({ field }) => (
                  <TextField
                    className="customTextBox"
                    {...field}
                    label="Formato"
                    value={field.value || ""}
                    fullWidth
                    margin="normal"
                    error={!!errors.formato}
                    helperText={errors.formato?.message}
                    disabled
                  />
                )}
              />
            </Grid>
            <Grid size={5}>
              <Controller
                name="bottiglie"
                control={control}
                render={({ field }) => (
                  <TextField
                    className="customTextBox"
                    {...field}
                    value={field.value || ""}
                    label="Bottiglie (UM)"
                    fullWidth
                    margin="normal"
                    error={!!errors.bottiglie}
                    helperText={errors.bottiglie?.message}
                    disabled
                  />
                )}
              />
            </Grid>
            <Grid size={2}>
              <Controller
                name="price"
                control={control}
                render={({ field }) => (
                  <TextField
                    className="customTextBox"
                    {...field}
                    value={field.value || ""}
                    label="120"
                    fullWidth
                    margin="normal"
                    error={!!errors.price}
                    helperText={errors.price?.message}
                  />
                )}
              />
            </Grid>
          </Grid>

          <label
            style={{
              display: "block",
              marginTop: "1%",
              marginBottom: "10%",
              fontWeight: "400",
              fontSize: "10px",
              lineHeight: "100%",
              textAlign: "right"
            }}
          >
            Q.ta dis.: {price}
          </label>

          <div className="btnPart1" style={{ mt: "10px" }}>
            <Button type="submit" variant="contained">
              Salva dati
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default TransportoForm;
